$(document).ready(function () {
    if (!$('#tariff-addons-page-container').length) {
        return;
    }

    $('.tariff-links-wrapper a').on('click', function (e) {
        e.preventDefault()

        let type = $(this).data('type');

        $('.tariff_addition_card').each(function () {
            if ($(this).data('types').includes(type)) {
                $(this).show()
            } else {
                $(this).hide()
            }
        })
    })
})
